var map = {
	"./euro2024.webp": 1506,
	"./euro2024_title.svg": 1507,
	"./event-sport-bg.jpg": 1508,
	"./event-sport-bg.png": 1509,
	"./home-icon-active.webp": 1510,
	"./home-icon.webp": 1511,
	"./img_bg-uefa.png": 1512,
	"./live-icon-active.webp": 1513,
	"./master-bg.webp": 1514,
	"./me-icon-active.webp": 1515,
	"./product-overview-bg.webp": 1516,
	"./promos-icon-active.webp": 1517,
	"./sponsor-icon-active.webp": 1518,
	"./uefa-icon-active.webp": 1519,
	"./uefa-icon.webp": 1520,
	"./uefa-prediction.webp": 1521,
	"./wwr-img.webp": 1522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;